// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "wangeditor" + "." + "7d4e063f" + ".chunk.css";
};